import { getConfigArrayNumber } from "../util/config";

// Actions
export const INDEX_REQUEST: string = "Reports/INDEX_REQUEST";
export const INDEX_SUCCESS: string = "Reports/INDEX_SUCCESS";
export const INDEX_FAILURE: string = "Reports/INDEX_FAILURE";

export const STORE_REQUEST: string = "Reports/STORE_REQUEST";
export const STORE_SUCCESS: string = "Reports/STORE_SUCCESS";
export const STORE_FAILURE: string = "Reports/STORE_FAILURE";

export const SHOW_REQUEST: string = "Reports/SHOW_REQUEST";
export const SHOW_SUCCESS: string = "Reports/SHOW_SUCCESS";
export const SHOW_FAILURE: string = "Reports/SHOW_FAILURE";

export const UPDATE_REQUEST: string = "Reports/UPDATE_REQUEST";
export const UPDATE_SUCCESS: string = "Reports/UPDATE_SUCCESS";
export const UPDATE_FAILURE: string = "Reports/UPDATE_FAILURE";

export const DESTROY_REQUEST: string = "Reports/DESTROY_REQUEST";
export const DESTROY_SUCCESS: string = "Reports/DESTROY_SUCCESS";
export const DESTROY_FAILURE: string = "Reports/DESTROY_FAILURE";

export const REPORT_TYPES_INDEX_REQUEST: string = "ReportTypes/INDEX_REQUEST";
export const REPORT_TYPES_INDEX_SUCCESS: string = "ReportTypes/INDEX_SUCCESS";
export const REPORT_TYPES_INDEX_FAILURE: string = "ReportTypes/INDEX_FAILURE";

export const REPORT_TYPE_STATEMENT_IDS: number[] = getConfigArrayNumber("REPORT_TYPE_STATEMENT_IDS").sort() ;
export const REPORT_TYPE_CUSTOM_IDS: number[] = getConfigArrayNumber("REPORT_TYPE_CUSTOM_IDS").sort();
